import React, { Component } from "react";

/** Remove legacy embedded benefit rows from statement HTML. */
function stripEmbeddedBenefitParagraph(html) {
  return String(html || "").replace(
    /<p class="(?:indicator-benefit|sentence-trends-indicator-benefit|sentence-trends-indicator-benefit-old)">[\s\S]*?<\/p>/gi,
    "",
  );
}

/**
 * Same layout as DBIndicator; main copy in `statement`, optional extra copy in
 * `logic`. Seller/buyer advantage line from `benefit` is rendered centered on its
 * own row below the relevant paragraph (statement or logic), not inline in HTML.
 */
class SentenceTrendsIndicatorOld extends Component {
  //testing
  determineBenefit = (benefit) => {
    if (benefit === "Seller's") {
      return "A Seller's Advantage";
    }
    if (benefit === "buyer's") {
      return "A Buyers Advantage";
    }
    return "";
  };

  renderBenefitRow = (benefitLine, modifierClass) => (
    <div
      className={`sentence-trends-indicator-benefit-row-old${
        modifierClass ? ` ${modifierClass}` : ""
      }`}
    >
      <p className="sentence-trends-indicator-benefit-old">{benefitLine}</p>
    </div>
  );

  render() {
    const { statement, header, logic, index, benefit } = this.props;

    const logicTrimmed = logic && String(logic).trim();
    const logicHtml = logicTrimmed ? String(logic) : "";
    const benefitLine = benefit ? this.determineBenefit(benefit) : "";

    let indicatorExplanationStyles = "";
    let indicatorAdvantageStyles;
    if (logicHtml && logicHtml.length < 60) {
      indicatorAdvantageStyles = "sentence-trends-indicator-advantage-left-old";
    }

    let headerStyles;
    if (header && header.length >= 33) {
      headerStyles = "sentence-trends-header-more-width-old";
    } else if (header && header.length >= 39) {
      headerStyles = "sentence-trends-indicator-medium-header-old";
    }

    const dbBoxStyles = "";
    const statementHtml = stripEmbeddedBenefitParagraph(statement);

    return (
      <div className="sentence-trends-indicator-old">
        <p
          className={`sentence-trends-indicator-header-num-old sentence-trends-header-num-${index}-old`}
        >
          {index}
        </p>

        <div className="sentence-trends-indicator-surface-old">
          <div className="sentence-trends-divider-old" />
          <div
            className={`sentence-trends-box-inner-container-old sentence-trends-box-inner-${
              index & 1 ? "odd" : "even"
            }-old ${dbBoxStyles}`}
          >
            <div className="sentence-trends-indicator-header-old">
              <p
                className={`sentence-trends-indicator-header-category-old ${headerStyles}`}
              >
                {header}
              </p>
            </div>

            <div
              className={`sentence-trends-indicator-explanation-old ${indicatorExplanationStyles}`}
              dangerouslySetInnerHTML={{ __html: statementHtml }}
            />
            {benefitLine && !logicTrimmed
              ? this.renderBenefitRow(benefitLine, "")
              : null}
            {logicTrimmed ? (
              <div className="sentence-trends-indicator-advantage-and-benefit-container-old">
                <div
                  className={`sentence-trends-indicator-advantage-old ${indicatorAdvantageStyles}`}
                >
                  <div dangerouslySetInnerHTML={{ __html: logicHtml }} />
                </div>
                {benefitLine
                  ? this.renderBenefitRow(
                      benefitLine,
                      "sentence-trends-indicator-benefit-row--after-logic-old",
                    )
                  : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default SentenceTrendsIndicatorOld;
